import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClosedByteChannelExceptionClass;
function ClosedByteChannelException() {
  if (ClosedByteChannelExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(cause) {
        return new.target.r4m(cause);
      }
      static r4m(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.a4l(cause == null ? null : cause.message, cause);
        captureStack($this, $this.q4m_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedByteChannelException', $.r4m);
    ClosedByteChannelExceptionClass = $;
  }
  return ClosedByteChannelExceptionClass;
}
var ClosedReadChannelExceptionClass;
function ClosedReadChannelException() {
  if (ClosedReadChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.g4m(cause);
      }
      static g4m(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.r4m(cause);
        captureStack($this, $this.f4m_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedReadChannelException', $.g4m);
    ClosedReadChannelExceptionClass = $;
  }
  return ClosedReadChannelExceptionClass;
}
var ClosedWriteChannelExceptionClass;
function ClosedWriteChannelException() {
  if (ClosedWriteChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.m4m(cause);
      }
      static m4m(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.r4m(cause);
        captureStack($this, $this.l4m_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedWriteChannelException', $.m4m);
    ClosedWriteChannelExceptionClass = $;
  }
  return ClosedWriteChannelExceptionClass;
}
//region block: exports
export {
  ClosedByteChannelException as ClosedByteChannelException3il8gfpye60w,
  ClosedReadChannelException as ClosedReadChannelException9jdpzh6uy12w,
  ClosedWriteChannelException as ClosedWriteChannelException1eeenxj0c4bxu,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
